import React from 'react';
 
const Tercero = () => {
    return (
        <div className='seccion'>
			
			<h1>PROGRAMAS DE ESTUDIOS - 2025</h1>

            <h4>Materias Plan Institucional - 3er año</h4>

            <div className="contenedor-tablas">
			<table className="tabla-programas">
            
                <caption>3er Año</caption>
				<tr>

					<th>Areas</th>
					<th>Espacio Curricular</th>
					<th>Programa</th>
 
				</tr>

				<tr>
					<td>Ciencias Sociales Politicas y Economicas</td>
					<td>Historia <br/> Construccion Ciudadana <br/> Geografia <br/> Economia </td>
					<td><a href="https://drive.google.com/drive/folders/1w9EXw-CC_SHVQoBWDaCx3Q5TsAuy6R8g?usp=drive_link" target="_blank" className="links" ><button>Click Aca</button></a></td>
				</tr>

				<tr>
					<td>Ciencias Naturales</td>
					<td> Fisica <br/> Biologia <br/> Quimica </td>
					<td><a href="https://drive.google.com/drive/folders/1mVBFEU5I7oseOgtrNgS-lh0hZ4NOv4q9?usp=drive_link" target="_blank" className="links" ><button>Click Aca</button></a></td>
				</tr>

				<tr>
					<td>Matematica / Informatica</td>
					<td> Matematica <br/> Informatica </td>
					<td><a href="https://drive.google.com/drive/folders/1D5UVvKitIt6VjjdN2HErmb9NoQBpFXcS?usp=drive_link" target="_blank" className="links" ><button>Click Aca</button></a></td>
				</tr>

				<tr>
					<td>Lengua y Produccion Artistica</td>
					<td> Lengua <br/> Lengua Preexistentes <br/> Ingles (Lenguas Otras) <br/> Artes Visuales <br/> Teatro <br/> Musica </td>
					<td><a href="https://drive.google.com/drive/folders/1AYDLLsgbwoXFDdYgnFGtYO48SXbFYlWO?usp=drive_link" target="_blank" className="links" ><button>Click Aca</button></a></td>
				</tr>

				<tr>
					<td>Comunicacion y Medios</td>
					<td>Comunicacion y Medios</td>
					<td><a href="https://drive.google.com/drive/folders/1JdfT9IfBb6E6gGQmE210rKjVxq0bgJO8?usp=drive_link" target="_blank" className="links" ><button>Click Aca</button></a></td>
				</tr>

				<tr>
					<td> Integracion Tecnologica </td>
					<td> Integracion Tecnologica </td>
					<td><a href="https://drive.google.com/drive/folders/1-kha9-woE61NKVP0yZExM9fMYUXB7-SM?usp=drive_link" target="_blank" className="links" ><button>Click Aca</button></a></td>
				</tr>

				<tr>
					<td> Educacion Fisica Integral </td>
					<td> Educacion Fisica Integral </td>
					<td><a href="https://drive.google.com/drive/folders/1jAN3-S-IKhcLEzhrlirTLcGChoPyG-e5?usp=drive_link" target="_blank" className="links" ><button>Click Aca</button></a></td>
				</tr>

				<tr>
					<td> Investigaciones de las Orientaciones </td>
					<td> Investigaciones de las Orientaciones </td>
					<td><a href="https://drive.google.com/drive/folders/1SXD-f9FebMVWsBhT0GGeUc-5cC3jkKwh?usp=drive_link" target="_blank" className="links" ><button>Click Aca</button></a></td>
				</tr>

			</table>

		</div>            


        </div>
    );
}

export default Tercero;
